/* The first message at the top of the visible list (within 20px above its
   edge), as { messageId, offsetFromTop }. The rows stand in document order, so
   a binary search finds it in a handful of measurements; it runs on every
   scroll event, and the linear walk it replaced measured every row above the
   viewport, which grew with each page of history (audit 2026-10-02). */
export function firstVisibleMessage(list) {
  const rows = list.querySelectorAll('[data-message-id]')
  if (!rows.length) return null
  const edge = list.getBoundingClientRect().top - 20
  let lo = 0, hi = rows.length - 1, found = -1
  while (lo <= hi) {
    const mid = (lo + hi) >> 1
    if (rows[mid].getBoundingClientRect().top >= edge) { found = mid; hi = mid - 1 } else lo = mid + 1
  }
  if (found < 0) return null
  const el = rows[found]
  return { messageId: el.getAttribute('data-message-id'), offsetFromTop: el.getBoundingClientRect().top - (edge + 20) }
}
